import { put, select } from 'redux-saga/effects';
import * as Sentry from '@sentry/react';
import {
  embedPlayerStateApplied,
  selectActiveFile,
} from 'features/content-library/contentLibrarySlice';
import { signalingContentLibraryMediaPlayerStateChanged } from 'features/content-library/actions';
import { ContentLibraryOpenedFile } from 'features/content-library/types';
import { logger } from 'utils/logger';
import { recordInboundForPairedArrivalWatch } from 'features/content-library/sagas/embedPlayerUserActionSaga';

export function* onContentLibraryMediaPlayerRemoteStateChangedSaga(
  action: ReturnType<typeof signalingContentLibraryMediaPlayerStateChanged>
) {
  if (!action.payload) {
    return;
  }

  recordInboundForPairedArrivalWatch(action.payload.id);

  const file: ContentLibraryOpenedFile | undefined = yield select(
    selectActiveFile,
    action.payload.id
  );
  const isAudio = file?.type === 'audio';

  // Bug C watch: inbound volume:0 while playing should never occur post-fix — alerts if a dispatch site is still emitting it.
  if (action.payload.volume === 0 && action.payload.state === 'playing') {
    const extra = { id: action.payload.id, payload: action.payload };
    Sentry.captureMessage('mp3-volume-zero-on-playing-inbound', { level: 'warning', extra });
    if (isAudio) {
      logger
        .remote({ capture: 'mp3-debug', nonProd: true })
        .warn('[remoteStateSaga] residual volume:0 poisoning detected', extra);
    }
  }

  if (isAudio) {
    logger.remote({ capture: 'mp3-debug', nonProd: true }).log('[remoteStateSaga] inbound', {
      id: action.payload.id,
      payload: action.payload,
    });
  }

  yield put(embedPlayerStateApplied(action.payload, { source: 'live' }));
}
